export default "__VITE_ASSET__DowW8YjY__"